/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PerfEnergyKpiType } from '../../models/perf-energy-kpi-type';
import { PerfEnergyTimeSeries } from '../../models/perf-energy-time-series';

export interface GetPerfEnergyTimeSeries$Json$Params {

/**
 * The type of KPI, we want to GET
 */
  kpiType: PerfEnergyKpiType;
  
    /**
     * Body for search kpi
     */
    body?: {
'startDateTime'?: string;
'endDateTime'?: string;

/**
 * List of station's uid used for filter
 */
'stationUids'?: Array<string>;
}
}

export function getPerfEnergyTimeSeries$Json(http: HttpClient, rootUrl: string, params: GetPerfEnergyTimeSeries$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<PerfEnergyTimeSeries>> {
  const rb = new RequestBuilder(rootUrl, getPerfEnergyTimeSeries$Json.PATH, 'post');
  if (params) {
    rb.path('kpiType', params.kpiType, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PerfEnergyTimeSeries>;
    })
  );
}

getPerfEnergyTimeSeries$Json.PATH = '/custom/time-series/perf-energy/{kpiType}';
